export const simulationStatus = {
  ACCEPTED: 'ACCEPTED', // Simulation engine acknowledged the receipt of the simulation to be processed
  CANCELED: 'CANCELED', // Simulation has been canceled by the user
  CREATED: 'CREATED', // Simulation has been created but not yet submitted to the simulation engine
  DELETING: 'DELETING', // Simulation has been requested to be deleted
  FAILED: 'FAILED', // Simulation was running but an issue has been raised
  FINISHED: 'FINISHED', // Simulation has ran successfully
  PREPARING: 'PREPARING', // Simulation engine is generating the simulation files
  REJECTED: 'REJECTED', // Simulation has not been accepted by the simulation engine
  RUNNING: 'RUNNING', // Simulation is running
  SUBMITTED: 'SUBMITTED', // Simulation has been submitted but not yet acknowledged
  WAITING: 'WAITING' // Simulation is waiting for others to be completed
}

// Statuses which can be canceled
export const simulationStatusStoppable = [simulationStatus.PREPARING, simulationStatus.RUNNING]

// Only final statuses can be deleted
export const simulationStatusDeletable = [
  simulationStatus.CANCELED,
  simulationStatus.FAILED,
  simulationStatus.FINISHED,
  simulationStatus.REJECTED
]
